import React from 'react';
import qs from 'qs';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { LoadingDots } from '@joinclyde/clyde-react-components';
import { verifyShopifyShopOAuth } from '../../actions/authActions';

class VerifyShopifyShop extends React.Component {
  componentDidMount() {
    const query = this.props.location.search.slice(1);
    this.props._verifyShopifyShopOAuth({
      ...qs.parse(query),
      platform: 'Shopify',
      source: 'dashboard',
    });
  }

  render() {
    return (
      <div className='gradient'>
        <LoadingDots dotColor='clydeBlack' dotSize='large' />
      </div>
    );
  }
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => bindActionCreators(
  { _verifyShopifyShopOAuth: verifyShopifyShopOAuth },
  dispatch,
);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VerifyShopifyShop));
